import { OnInit, Component, Input, NgZone } from "@angular/core";
import { MainPageService } from "../../main-page.service";
import { StpConfigureService } from "../stp-configure.service";
import { ExtensionInterface } from "../../../models/viewer/ExtensionInterface.model";

@Component({
    selector: 'profiles-configure',
    template: `<div class="arms-table">
    <span>Groups:</span>
    <div class="display-flex">
        <select name="groupSelect" style="width: 80%;" [(ngModel)]="currentChoosenArmGroup" (change)="onGroupChange()">
            <option *ngFor="let armGroup of profileData.armGroups" [ngValue]="armGroup._id" selected="armGroup._id===currentChoosenGroup">{{armGroup.armGroupName}}</option>
        </select>
        <div style="padding-left: 20px;">
            <i class="material-icons icon-button" data-toggle="modal" data-target="#addModal">
                add_circle
            </i>
            <i class="material-icons icon-button" data-toggle="modal" data-target="#confirmationModal">
                remove_circle
            </i>
        </div>
    </div>
    <div style="overflow-y: auto; height: calc(100% - 65px);">
        <table>
            <colgroup>
                <col span="1" style="width: 100%;">
            </colgroup>
            <thead>
                <tr>
                    <th>Channels</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let arm of profileData.armGroups[currentChoosenArmGroup - 1].arms">
                    <td>
                        <div class="armHeaderLabel">
                            {{ arm.name }}
                            <i class="material-icons icon-button add-profile-btn" (click)="addCrossSection(arm)">
                                add_circle
                            </i>
                        </div>
                        <table>
                            <colgroup>
                                <col span="1" style="width: 10%;">
                                <col span="1" style="width: 30%;">
                                <col span="1" style="width: 51%;">
                                <col span="1" style="width: 20%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Profile name</th>
                                    <th>Rotation</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let crossSection of arm.crossSections">
                                    <td>
                                        <i class="material-icons icon-button clickable" [hidden]="crossSection.isShown" (click)="showCrossSection(arm, crossSection)">
                                            visibility_off
                                        </i>
                                        <i class="material-icons icon-button clickable" [hidden]="!crossSection.isShown">
                                            visibility
                                        </i>
                                    </td>
                                    <td>
                                        <ng-select [items]="crossSectionOptions" [active]="crossSection.activeCrossSection" (selected)="crossSectionChanged(arm, crossSection, $event)"></ng-select>
                                    </td>
                                    <td>
                                        <div class="btn-group btn-group-toggle">
                                            <label class="red-button" ngbButtonLabel>
                                                <input type="checkbox" ngbButton [(ngModel)]="crossSection.allow0rotation" [disabled]="crossSection.allow0rotation" (change)="rotationChanged(arm, crossSection, 0)"> 0
                                            </label>
                                            <label class="red-button" ngbButtonLabel>
                                                <input type="checkbox" ngbButton [(ngModel)]="crossSection.allow90rotation" [disabled]="crossSection.allow90rotation" (change)="rotationChanged(arm, crossSection, 90)"> 90
                                            </label>
                                            <label class="red-button" ngbButtonLabel>
                                                <input type="checkbox" ngbButton [(ngModel)]="crossSection.allow180rotation" [disabled]="crossSection.allow180rotation" (change)="rotationChanged(arm, crossSection, 180)"> 180
                                            </label>
                                            <label class="red-button" ngbButtonLabel>
                                                <input type="checkbox" ngbButton [(ngModel)]="crossSection.allow270rotation" [disabled]="crossSection.allow270rotation" (change)="rotationChanged(arm, crossSection, 270)"> 270
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <i class="material-icons icon-button" (click)="removeCrossSection(arm, crossSection)">
                                            remove_circle
                                        </i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- Confiramtion Modal -->
<div class="modal" id="confirmationModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div>
                    Do you want to remove current group?
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger save-button" data-dismiss="modal" (click)="removeCurrentArmGroup()">Remove</button>
            </div>

        </div>
    </div>
</div>

<!-- Add Modal -->
<div class="modal" id="addModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Group name: &nbsp;</span>
                    <input type="text" #newGroupName>
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger save-button" data-dismiss="modal" (click)="addNewArmGroup(newGroupName.value)">Save</button>
            </div>

        </div>
    </div>
</div>`,
    styles: [`.armHeaderLabel{text-align:left;margin-left:6px;font-size:16px!important;height:32px;display:flex;align-items:center;position:relative}.add-profile-btn{position:absolute;right:10px}.clickable{cursor:pointer}.buttonTransparent{padding:0;background-color:transparent;border:none}.buttonTransparent:disabled{opacity:.2}.inner-table{display:block;overflow-y:auto;overflow-x:hidden}`, `table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:1px}tr:nth-child(even){background-color:#ddd}.icon-button{cursor:pointer;font-size:30px;vertical-align:middle}.icon-button .close-icon{cursor:pointer;position:absolute;right:10px}.steps{display:flex;list-style:none;align-items:center;margin:0;height:60px;padding:0;justify-content:space-between}.btnStep{color:#000;font-weight:700;font-size:14px;letter-spacing:.5px;background-color:transparent;border:0;outline:0}.btnStep:disabled{opacity:.6!important;cursor:default}.step::before{background-color:#ccc9cc;margin-left:16px;min-width:70%;height:2px}.step:nth-child(1) .btnStep::before{content:"1"}.step:nth-child(2) .btnStep::before{content:"2"}.step:nth-child(3) .btnStep::before{content:"3"}.step:nth-child(4) .btnStep::before{content:"4"}.step:nth-child(5) .btnStep::before{content:"5"}.step:nth-child(6) .btnStep::before{content:"6"}.btnStep::before{display:inline-block;width:40px;min-width:40px;height:40px;border:0;border-radius:50%;right:0;background-color:#000;margin-right:12px;text-align:center;color:#fff;line-height:40px;font-size:13px}.arms-table{bottom:41px;right:18px;height:100%;background-color:#fff}.arms-table td,.arms-table th{text-align:center}.red-button{font-family:inherit;padding:7px 14px}.currentTab::before{background-color:#d0021b!important}.display-flex{display:flex;margin-bottom:10px}`]
})

export class ProfilesConfigureComponent implements OnInit {
    private extensionInterface: ExtensionInterface;
    public profileData: any;
    public crossSectionOptions = [];
    public armData = [];
    public dirOptions = [];
    public releaseCodeOptions = [];
    public currentChoosenArmGroup: number = 1;

    @Input() set ExtensionInterface(value: ExtensionInterface) {
        this.extensionInterface = value;
        if (this.extensionInterface !== null) {
            this.extensionInterface.loadingCompleated.subscribe(() => {
                this.zone.run(() => {
                    this.showProfilesConfiguration();
                });
            });
        }
    }

    constructor(private mainPageService: MainPageService,
        private stpConfigureService: StpConfigureService,
        private zone: NgZone
    ) {
        this.profileData = { armGroups: [{ arms: [] }] };
    }

    ngOnInit(): void {
        this.mainPageService.loadAllCrossSections().subscribe((allCrossSections) => {
            this.crossSectionOptions.splice(0, this.crossSectionOptions.length);//clear array
            for (var j = 0; j < allCrossSections.length; j++) {
                var crossSection = allCrossSections[j];
                this.crossSectionOptions.push({ id: crossSection._id, text: crossSection.name });
            }
        });
    }

    saveConfiguration() {
        const data = this.extensionInterface.getConnectorCrossSectionsConfig();
        this.stpConfigureService.saveConnectorVariantConfiguration(data).subscribe(() => {
        });
    }

    showProfilesConfiguration(): void {
        if (!this.extensionInterface.verifyArmDefinitionForProfileConfiguration(this.currentChoosenArmGroup)) {
            this.extensionInterface.resetConnectorCrossSectionsConfig();
            this.saveConfiguration();
        }
        this.profileData = this.extensionInterface.getConnectorCrossSectionsConfig();
        this.extensionInterface.showConnectorCrossSections(this.currentChoosenArmGroup);
    }

    addCrossSection(arm) {
        this.extensionInterface.createEmptyConnectorCrossSection(arm, this.currentChoosenArmGroup);
        this.profileData = this.extensionInterface.getConnectorCrossSectionsConfig();
    }

    removeCrossSection(arm, crossSection) {
        var ind = arm.crossSections.indexOf(crossSection);
        arm.crossSections.splice(ind, 1);
        this.extensionInterface.removeCrossSectionForArm(arm, crossSection);
        this.saveConfiguration();
    }

    crossSectionChanged(arm, crossSection, event) {
        crossSection.crossSectionId = event.id;
        crossSection.crossSectionName = event.text;
        this.extensionInterface.changeShownCrossSection(arm, crossSection, this.currentChoosenArmGroup);
        this.saveConfiguration();
    }

    showCrossSection(arm, crossSection) {
        this.extensionInterface.changeShownCrossSection(arm, crossSection, this.currentChoosenArmGroup);
    }

    rotationChanged(arm, crossSection, angle) {
        if (angle !== 0) crossSection.allow0rotation = false;
        if (angle !== 90) crossSection.allow90rotation = false;
        if (angle !== 180) crossSection.allow180rotation = false;
        if (angle !== 270) crossSection.allow270rotation = false;

        crossSection.rotationAngle = angle / 180 * Math.PI;

        this.extensionInterface.changeShownCrossSection(arm, crossSection, this.currentChoosenArmGroup);
        this.saveConfiguration();
    }

    hideCrossSections() {
        this.extensionInterface.hideConnectorCrossSections();
    }

    addNewArmGroup(newGroupName) {
        this.extensionInterface.createEmptyArmGroup(newGroupName);
        this.saveConfiguration();
        this.currentChoosenArmGroup = this.profileData.armGroups.length;
        this.showProfilesConfiguration();
    }

    removeCurrentArmGroup() {
        if (this.currentChoosenArmGroup !== 1) {
            const groupToRemove = this.profileData.armGroups[this.currentChoosenArmGroup - 1];
            this.extensionInterface.removeArmGroup(groupToRemove);
            this.saveConfiguration();
            if (this.profileData.armGroups[this.currentChoosenArmGroup - 1] === undefined) {
                this.currentChoosenArmGroup = this.currentChoosenArmGroup - 1;
            }
            this.showProfilesConfiguration();
        }
    }

    onGroupChange() {
        this.showProfilesConfiguration();
    }
}
